import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IImgTitleDescriptionComponentProps } from '../components/img-title-description/img-title-description';
import { Models } from '.';
import { IButtonProps } from '../components/button/button';

export class ImageTitleDescriptionModel extends ContentItem {
  get img(): string {
    return get(this._config, 'elements.image.value[0].url', '');
  }
  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get description(): string {
    return get(this._config, 'elements.description_value.value', '');
  }

  get uniqueId(): string {
    return get(this._config, 'elements.unique_id.value', '');
  }

  get descriptionHasOverlay(): boolean {
    return (
      get(
        this._config,
        'elements.description_has_overlay.value[0].codename',
        ''
      ) === 'true'
    );
  }

  get hasHoverEffect(): boolean {
    return (
      get(this._config, 'elements.has_hover_effect.value[0].codename', '') ===
      'true'
    );
  }

  get justifyContent(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_column.value[0].codename',
      'center'
    );
  }

  get alignItems(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_row.value[0].codename',
      'center'
    );
  }

  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      'primary'
    );
  }

  get textColor(): string {
    return get(
      this._config,
      'elements.color__text_color.value[0].codename',
      'primary'
    );
  }
  get withBorder(): boolean {
    return JSON.parse(
      get(this._config, 'elements.with_border.value[0].codename', 'false')
    );
  }
  get fullWidth(): string {
    const fullWidth = this?._config?.elements?.full_width.value[0]?.codename;
    return fullWidth ?? 'no';
  }
  get button(): IButtonProps | null {
    const getData = get(this._config, 'elements.button.value[0]', null);
    return getData ? Models.ButtonModel.create(getData as IButton) : null;
  }
  get urlToPage(): string {
    return get(
      this._config,
      'elements.page.value[0].elements.basic_page_settings__url.value',
      null
    );
  }

  public static create(
    data: IImageTitleDescription
  ): IImgTitleDescriptionComponentProps {
    const {
      img,
      title,
      description,
      alignItems,
      justifyContent,
      backgroundColor,
      textColor,
      withBorder,
      fullWidth,
      button,
      urlToPage,
      descriptionHasOverlay,
      hasHoverEffect,
      uniqueId
    } = new ImageTitleDescriptionModel(data);

    return {
      img,
      title,
      description,
      alignItems,
      justifyContent,
      backgroundColor,
      textColor,
      withBorder,
      fullWidth,
      button,
      urlToPage,
      descriptionHasOverlay,
      hasHoverEffect,
      uniqueId
    };
  }
}
